import { useHomeReactFlow } from "@custom-hooks/HomeUsePluginRoot/useHomeReactFlow";
import func from "@uikit/func";
import { logEvent } from "@uikit/service/amplitude";
import { cloneDeep, map } from "lodash";
import { useCallback, useMemo } from "react";
import { HomeMethodsUtil } from "@uikit/util/_homeUtil";
import { previewStore } from "@uiview/store/PreviewStore";
import { CreatorAISaasStore } from "./store/CreatorAISassStore";
import { getIt } from "@uikit/getIt";
import { CreatorSaasAppStore } from "./store/CreatorSaasAppStore";
import { HomeMethodsService } from "@uikit/service/HomeMethodsService";
import { CreatorNodesStore } from "@uiview/views/ProjectCanvas/store/CreatorNodesStore";
import { ProjectNodeStore } from "@uikit/projectNode/ProjectNodeStore";

// eslint-disable-next-line
export function useHomeDeleteMethods() {
  const creatorAISassStore = getIt(CreatorAISaasStore);
  const creatorSaasAppStore = getIt(CreatorSaasAppStore);
  const homeMethods = getIt(HomeMethodsService);
  const creatorNodesStore = getIt(CreatorNodesStore);
  const projectNodeStore = getIt(ProjectNodeStore);

  const { deleteNodeByIds } = useHomeReactFlow();

  const handleSaasDeleteNodes = useCallback(
    (saasDataObj: any, newThoughts: AISaasOutput.ThoughtType[], nodeIds: any[] = []) => {
      const newInputNode = HomeMethodsUtil.deleteInputNode(saasDataObj, nodeIds);
      // stud-2493 set input(preview)
      creatorSaasAppStore.setSaasUIData((prevData: any) => {
        return {
          ...prevData,
          input: newInputNode,
          output: newThoughts,
        };
      });
      projectNodeStore.composeNodes(creatorNodesStore.getNodes(), creatorSaasAppStore.state.saasUIData);

      const newInputNodeId = newInputNode.map((x: { id: any }) => x.id);
      creatorAISassStore.setInputId(newInputNodeId);
    },
    []
  );

  const handleDeleteGroupNodeByPreviewBtn = useCallback(
    (groupId: any) => {
      const uiType = previewStore.state.selectedUI;
      if (func.isEmpty(uiType)) return;
      // bsf-4912 replace thoughts
      let copyThoughts = cloneDeep(creatorSaasAppStore.state.saasUIData.output);
      copyThoughts = copyThoughts.filter(x => !x?.groupId || x.groupId !== groupId);
      const saasActionObj = homeMethods.getSaasAction();
      if (func.isEmpty(saasActionObj)) return;
      handleSaasDeleteNodes(saasActionObj, copyThoughts);
    },
    // eslint-disable-next-line
    [handleSaasDeleteNodes]
  );

  const handleDeleteSingleNodeByPreviewBtn = useCallback(
    (nodeId: string) => {
      const uiType = previewStore.state.selectedUI;
      if (func.isEmpty(uiType)) return;
      // const nodeIds = nodes.map(x => x.id);
      // bsf-4912 replace thoughts
      let copyThoughts = cloneDeep(creatorSaasAppStore.state.saasUIData.output);
      copyThoughts = copyThoughts
        .map(item => {
          if (item.groupId) {
            return item;
          }
          item.results = item.results.filter(child => child.nodeId !== nodeId);
          return item;
        })
        .filter(x => x.results.length > 0);
      const saasActionObj = homeMethods.getSaasAction();
      if (func.isEmpty(saasActionObj)) return;
      handleSaasDeleteNodes(saasActionObj, copyThoughts);
    },
    // eslint-disable-next-line
    [handleSaasDeleteNodes]
  );

  const handleDeleteNodes = useCallback(
    (nodes: any[]) => {
      const nodesCopy = creatorNodesStore.getNodes();
      deleteNodeByIds(map(nodes, "id"));
      if (nodes.length === 1) {
        const nodeitem = nodes[0];
        const parentNodeId = nodesCopy.find(item => {
          return item.id === nodeitem.id;
        })?.data?.parentNodeId;
        setTimeout(() => {
          creatorAISassStore.setGroupDeleteChildNode({ id: nodeitem.id, parentNodeId: parentNodeId });
        }, 300);
      }
      const uiType = previewStore.state.selectedUI;
      if (func.isEmpty(uiType)) return;
      const nodeIds = nodes.map(x => x.id);
      // bsf-4912 replace thoughts
      let copyThoughts = cloneDeep(creatorSaasAppStore.state.saasUIData.output);
      copyThoughts = copyThoughts
        .map(item => {
          item.results = item.results.filter(child => nodeIds.includes(child.nodeId) === false);
          return item;
        })
        .filter(x => x.results.length > 0);
      const saasActionObj = homeMethods.getSaasAction();
      if (func.isEmpty(saasActionObj)) return;
      handleSaasDeleteNodes(saasActionObj, copyThoughts, nodeIds as any);
      logEvent("delete_node", {
        nodes,
      });
    },
    // eslint-disable-next-line
    [deleteNodeByIds, handleSaasDeleteNodes]
  );

  return useMemo(
    () => ({
      handleDeleteGroupNodeByPreviewBtn,
      handleDeleteSingleNodeByPreviewBtn,
      handleDeleteNodes,
      handleSaasDeleteNodes,
    }),
    [handleDeleteGroupNodeByPreviewBtn, handleDeleteNodes, handleDeleteSingleNodeByPreviewBtn, handleSaasDeleteNodes]
  );
}
